import { PriorityContactViewDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum PriorityContactEventTypes {
  PRIORITY_CONTACT_UPSERTED = '[Priority Contact] Upserted',
  PRIORITY_CONTACT_DELETED = '[Priority Contact] Deleted',
}

/**
 * Payloads
 */
export interface PriorityContactUpsertedEventPayload {
  priorityContactView: PriorityContactViewDto;
}

export interface PriorityContactDeletedEventPayload {
  memberId: string;
}

/**
 * Events
 */
export class PriorityContactUpsertedEvent {
  readonly type = PriorityContactEventTypes.PRIORITY_CONTACT_UPSERTED;

  constructor(public payload: PriorityContactUpsertedEventPayload) {}
}

export class PriorityContactDeletedEvent {
  readonly type = PriorityContactEventTypes.PRIORITY_CONTACT_DELETED;

  constructor(public payload: PriorityContactDeletedEventPayload) {}
}
